import { createComponent } from '@mtfe/sweet';
import {
    eventBus,
    common,
    createDeepLink,
} from '@mtfe/sweet-utils';
import { RedBagWithPoiList } from '@mtfe/sweet-components';
import { debounceByPromise } from '@mtfe/sweet-utils/lib/common';

import SkuCouponListV3 from '../../../../components/SkuCouponListV3/script';
import style from './style.less';
import tpl from './dom.html';

import store from '../../../../store/index';
import { useAutoLogin } from '../../../../utils';
import {
    fetchAllCoupon,
    fetchDataList,
    fetchOneRedBag,
} from '../../../../utils/fetchData';
import http from '../../../../service';
import { COUPON_STATUS } from '../../../../constants';

const { storeCommon } = store;
const { createUniqueId } = common;
const deepLink = createDeepLink();

const SMALL_BTN_ID = createUniqueId();
const BIG_BTN_ID = createUniqueId();
const HEADER_ID = createUniqueId();
const RECEIVED_HEADER_ID = createUniqueId();

let observer = null;

const getCouponAndMonitorPoiList = () => {
    const {
        dom_sg_every_day_coupon: domSgEveryDayCoupon,
        dom_sg_cps_unbind_multi_poi_1: domSgMultiPoi1,
        dom_sg_cps_unbind_multi_poi_2: domSgMultiPoi2,
        dom_sg_cps_unbind_multi_poi_3: domSgMultiPoi3,
    } = storeCommon.structInfo.struct;

    const storeSgEveryDayCoupon = store[domSgEveryDayCoupon.recallBizId];
    const storeSgMultiPoi1 = store[domSgMultiPoi1.recallBizId];
    const storeSgMultiPoi2 = store[domSgMultiPoi2.recallBizId];
    const storeSgMultiPoi3 = store[domSgMultiPoi3.recallBizId];

    const getAllClickMonitorList = [];
    const nweGiftInfoList = [];

    // 此处不考虑对商家数据做筛选，后端保证商家都有下挂菜，能在页面上展示出来
    if (storeSgEveryDayCoupon.isShow) {
        nweGiftInfoList.push(...storeSgEveryDayCoupon.discountData.couponList);
        // 后端在领券的同时会上报点击，无需额外上报点击，后端会做去重处理
        // getAllClickMonitorList.push(...storeSgEveryDayCoupon.poiData.poiList);
    }

    if (storeSgMultiPoi1.isShow) {
        nweGiftInfoList.push(storeSgMultiPoi1.discountData.redBagList[0]);
        getAllClickMonitorList.push(
            ...storeSgMultiPoi1.poiData.poiList.slice(0, 8),
        );
    }
    if (storeSgMultiPoi2.isShow) {
        nweGiftInfoList.push(storeSgMultiPoi2.discountData.redBagList[0]);
        getAllClickMonitorList.push(
            ...storeSgMultiPoi2.poiData.poiList.slice(0, 8),
        );
    }
    if (storeSgMultiPoi3.isShow) {
        nweGiftInfoList.push(storeSgMultiPoi3.discountData.redBagList[0]);
        getAllClickMonitorList.push(
            ...storeSgMultiPoi3.poiData.poiList.slice(0, 8),
        );
    }
    return {
        getAllClickMonitorList,
        nweGiftInfoList,
    };
};
const isGetAllCoupon = () => {
    const { nweGiftInfoList } = getCouponAndMonitorPoiList();

    const isGetAllGiftInfo = nweGiftInfoList.every((poiInfo) => {
        const { giftInfo } = poiInfo;
        return giftInfo.status === COUPON_STATUS.STATUS_RECEIVED;
    });
    return isGetAllGiftInfo;
};
const createRedBagWithPoiListObj = (redBag, poiData) => {
    const onCouponBtnClickHandler = async (
        redBagInfo,
        poiList,
        recallBizId,
    ) => {
        const { giftInfo } = redBagInfo;
        try {
            // 上报前8个
            if (giftInfo.status === COUPON_STATUS.STATUS_NEW) {
                // 如果是未领取过的券，领取券
                await fetchOneRedBag(redBagInfo, recallBizId);
            }
        } catch (error) {
            console.error(error);
        }
        http.multipleClickM(
            poiList.slice(0, 8).map((poiInfo) => {
                return poiInfo.clickMonitorUrl;
            }),
        );
    };
    const onMoreTipClickHandler = async (poiDataClick) => {
        try {
            const { poiList } = poiDataClick;
            const res = await fetchDataList(poiDataClick);
            if (res && Array.isArray(res)) {
                poiList.push(...res);
                return res;
            } else {
                return [];
            }
        } catch (error) {
            console.error(error);
            return [];
        }
    };
    const onPoiInfoClick = async (
        currentPoiInfo,
        redBagInfo,
        poiList,
        recallBizId,
    ) => {
        const { giftInfo } = redBagInfo;
        try {
            // 上报前8个
            if (giftInfo.status === COUPON_STATUS.STATUS_NEW) {
                // 如果是未领取过的券，领取券
                await fetchOneRedBag(redBagInfo, recallBizId);
            }
        } catch (error) {
            console.error(error);
        }
        deepLink.gotoDp(currentPoiInfo.dpUrl, currentPoiInfo.lpUrl, () => {
            // 统一上报前8个商家
            http.multipleClickM(
                poiList.slice(0, 8).map((poiInfo) => {
                    return poiInfo.clickMonitorUrl;
                }),
            );
        });
    };
    const onPoiObserverHandler = async (poiInfo) => {
        try {
            const url = `${poiInfo.impMonitorUrl}`;
            await http.gMonitorApi(url);
        } catch (error) {
            console.error('RedBagWithPoiList: 商家曝光上报失败', error);
        }
    };
    const onRedBagObserverHandler = async (redBagInfo) => {
        try {
            const url = `${redBagInfo.impMonitorUrl}`;
            await http.gMonitorApi(url);
        } catch (error) {
            console.error('RedBagWithPoiList: 红包曝光上报失败', error);
        }
    };

    const redBagObj = new RedBagWithPoiList({
        title: `${redBag.giftInfo.desc}${
            redBag.giftInfo.coupon_amount / 100
        }元`,
        subtitle: `以下店铺均可用, 限定商品满${
            redBag.giftInfo.order_amount_limit / 100
        }可用`,
        redBagInfo: redBag,
        poiList: poiData.poiList,
        recallBizId: poiData.recallBizId,
        onCouponBtnClick: debounceByPromise(
            useAutoLogin(onCouponBtnClickHandler),
        ),
        onMoreTipClick: () => {
            return onMoreTipClickHandler(poiData);
        },
        onPoiInfoClick: useAutoLogin(onPoiInfoClick),
        onPoiObserver: onPoiObserverHandler,
        onRedBagObserver: onRedBagObserverHandler,
    });
    return redBagObj;
};

const V3Ready = (redBagWithPoiListObjList) => {
    eventBus.$onceOn('V3Ready', () => {
        const { dom_sg_every_day_coupon: domSgEveryDayCoupon } =
            storeCommon.structInfo.struct;

        const storeSgEveryDayCoupon = store[domSgEveryDayCoupon.recallBizId];
        // 按钮
        const smallDom = document.getElementById(SMALL_BTN_ID);
        const bigBtnDom = document.getElementById(BIG_BTN_ID);

        if (smallDom && bigBtnDom) {
            if (window.IntersectionObserver) {
                observer = new IntersectionObserver(
                    (entires) => {
                        entires.forEach((entry) => {
                            if (entry.isIntersecting) {
                                bigBtnDom.style.display = 'none';
                            } else {
                                bigBtnDom.style.display = '';
                            }
                        });
                    },
                    {
                        threshold: 0.8,
                    },
                );
                observer.observe(smallDom);
            }
        }

        if (storeSgEveryDayCoupon.isShow) {
            eventBus.$emit('SkuCouponListV3Ready');
        }
        redBagWithPoiListObjList &&
            redBagWithPoiListObjList.forEach((obj) => {
                if (obj) {
                    obj.ready();
                }
            });
    });
};

const V3 = () => {
    try {
        const {
            dom_sg_every_day_coupon: domSgEveryDayCoupon,
            dom_sg_cps_unbind_multi_poi_1: domSgMultiPoi1,
            dom_sg_cps_unbind_multi_poi_2: domSgMultiPoi2,
            dom_sg_cps_unbind_multi_poi_3: domSgMultiPoi3,
        } = storeCommon.structInfo.struct;

        const storeSgEveryDayCoupon = store[domSgEveryDayCoupon.recallBizId];
        const storeSgMultiPoi1 = store[domSgMultiPoi1.recallBizId];
        const storeSgMultiPoi2 = store[domSgMultiPoi2.recallBizId];
        const storeSgMultiPoi3 = store[domSgMultiPoi3.recallBizId];

        const storeList = [
            storeSgMultiPoi1,
            storeSgMultiPoi2,
            storeSgMultiPoi3,
        ];
        const redBagWithPoiListObjList = storeList.map((currentStore) => {
            if (currentStore && currentStore.isShow) {
                const redBag = currentStore.discountData.redBagList[0];
                const poiData = currentStore.poiData;
                return createRedBagWithPoiListObj(redBag, poiData);
            }
            return null;
        });

        const data = {
            skuCouponList: '',
            SMALL_BTN_ID,
            BIG_BTN_ID,
            RECEIVED_HEADER_ID,
            HEADER_ID,
            redBag1: '',
            redBag2: '',
            redBag3: '',
            isGetAllCoupon: isGetAllCoupon(),
        };

        if (storeSgEveryDayCoupon.isShow) {
            data.skuCouponList = SkuCouponListV3();
        }
        redBagWithPoiListObjList.forEach((obj, index) => {
            if (obj) {
                data[`redBag${index + 1}`] = obj.getComponent();
            }
        });

        const getAllCoupon = async () => {
            const { nweGiftInfoList, getAllClickMonitorList } =
                getCouponAndMonitorPoiList();

            try {
                await fetchAllCoupon(
                    nweGiftInfoList,
                    storeSgEveryDayCoupon.recallBizId ||
                        storeSgMultiPoi1.recallBizId ||
                        storeSgMultiPoi2.recallBizId ||
                        storeSgMultiPoi3,
                );

                const isGetAllGiftInfo = isGetAllCoupon();

                const smallDom = document.getElementById(SMALL_BTN_ID);
                const bigBtnDom = document.getElementById(BIG_BTN_ID);
                if (isGetAllGiftInfo && smallDom && bigBtnDom) {
                    smallDom.style.display = 'none';
                    bigBtnDom.style.display = 'none';
                    observer && observer.unobserve(smallDom);
                }
                const headerDom = document.getElementById(HEADER_ID);
                const receivedHeaderDom =
                    document.getElementById(RECEIVED_HEADER_ID);

                if (isGetAllGiftInfo && headerDom && receivedHeaderDom) {
                    headerDom.style.display = 'none';
                    receivedHeaderDom.style.display = 'block';
                }

                http.multipleClickM(
                    getAllClickMonitorList.map((poiInfo) => {
                        return poiInfo.clickMonitorUrl;
                    }),
                );
            } catch (error) {
                console.error(error);
            }
        };
        const events = {
            onClickGetAllCoupon: debounceByPromise(
                useAutoLogin(getAllCoupon),
                500,
                true,
            ),
        };
        V3Ready(redBagWithPoiListObjList);
        return createComponent(tpl, { style, data }, events);
    } catch (error) {
        console.error(error);
        return '';
    }
};

export default V3;
